import styles from './SECCard.module.scss';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const cardBackgroundColorDefault = getComputedStyle(document.documentElement).getPropertyValue('--securikett-color-4')

function SECCard({ cardWidth = '50', cardHeight = 'auto', cardPadding = '20px 10px', cardBackgroundColor = cardBackgroundColorDefault, cardContentMinHeight = '100px', cardOverflow = 'auto', cardContentGrow = false, children }) {


    return (
        <div 
            className={styles["sec--card"]}
            style={{ 
                flex: cardWidth + '%',
                height: cardHeight
                }}>
            <Card
                sx={{ 
                    backgroundColor: cardBackgroundColor, 
                    padding: cardPadding, 
                    borderRadius: '15px', 
                    width: '100%'
                    }}>
                
                <CardContent style={
                    cardContentGrow ?   { overflow: cardOverflow, paddingBottom: '60px' } : 
                                        { height: '100%', minHeight: cardContentMinHeight, overflow: cardOverflow, paddingBottom: '60px' }
                    }>
                    {children}
                </CardContent>
            </Card>
        </div>
    )
}

export default SECCard;